import { useState, useEffect } from "react";
import { Receipt } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { agencyMenu } from "@/config/menus";
import { PageHeader, KpiCard } from "@/components/KpiCard";
import { StatusPill, inr, LoadingScreen, EmptyState } from "@/components/common";
import { Wallet, Clock, CheckCircle } from "lucide-react";

export default function AgencyInvoices() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/invoices/agency").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const paid = (rows || []).filter((i) => i.status === "PAID");
  const pending = (rows || []).filter((i) => i.status !== "PAID");
  const revenue = paid.reduce((s, i) => s + i.total, 0);

  return (
    <DashboardShell menu={agencyMenu} title="Invoices & Payouts">
      <PageHeader title="Invoices" subtitle="Revenue, commission and payout tracking." />
      {!rows ? <LoadingScreen /> : (
        <>
          <div className="grid grid-cols-3 gap-4 mb-6">
            <KpiCard icon={Wallet} label="Collected" value={inr(revenue)} accent testid="kpi-collected" />
            <KpiCard icon={Clock} label="Pending" value={pending.length} testid="kpi-pending-inv" />
            <KpiCard icon={CheckCircle} label="Paid" value={paid.length} testid="kpi-paid-inv" />
          </div>
          {rows.length === 0 ? <EmptyState icon={Receipt} title="No invoices yet" hint="Invoices are generated when contracts become active." /> : (
            <div className="bg-white border border-navy-200 rounded-xl overflow-x-auto">
              <table className="w-full text-sm min-w-[640px]">
                <thead className="bg-navy-50 text-navy-500 text-xs uppercase"><tr><th className="text-left p-3">Invoice</th><th className="text-left p-3">Customer</th><th className="p-3">Amount</th><th className="p-3">Total</th><th className="p-3">Due</th><th className="p-3">Status</th></tr></thead>
                <tbody>
                  {rows.map((i) => (
                    <tr key={i.id} className="border-t border-navy-100" data-testid={`ag-invoice-${i.id}`}>
                      <td className="p-3 font-mono text-navy-700">{i.invoice_no}</td>
                      <td className="p-3 text-navy-700">{i.customer_name}</td>
                      <td className="p-3 text-center text-navy-600">{inr(i.amount)}</td>
                      <td className="p-3 text-center font-bold text-navy-900">{inr(i.total)}</td>
                      <td className="p-3 text-center text-navy-600">{i.due_date}</td>
                      <td className="p-3 text-center"><StatusPill status={i.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </DashboardShell>
  );
}
